package one.healthium.data.user.dto


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.common.serializers.SafeFloatSerializer

@Serializable
internal data class UserProfileDto(
    @SerialName("name") val name: String? = null,
    @SerialName("age") val age: Int? = null,
    @SerialName("weight") @Serializable(with = SafeFloatSerializer::class) val weight: Float? = null,
    @SerialName("target_weight") @Serializable(with = SafeFloatSerializer::class) val targetWeight: Float? = null,
    @SerialName("height") @Serializable(with = SafeFloatSerializer::class) val height: Float? = null,
    @SerialName("gender") val gender: String? = null,
    @SerialName("email") val email: String? = null,
    @SerialName("avatar_url") val avatarUrl: String? = null,
    @SerialName("additional_info") val additionalInfo: Map<String, List<AdditionalUserInfoDto>>? = null,
    @SerialName("additional_text") val additionalText: Map<String, String>? = null,
    @SerialName("statements") val statements: Map<String, Int>? = null,
)